import "./WhatIfGridComponent.scss";
import {IComponentOptions, IOnChanges, IOnChangesObject, IOnInit, IRootElementService, ITimeoutService} from "angular";
import {ComponentCallback} from "../../../types/AngularJS";
import {Strategy} from "../../../strategybuilder/models/Strategy";
import {ObjectUtil} from "../../../js/util/ObjectUtil";
import {PortfolioPositions} from "../../models/Portfolio";
import {UserConfig} from "../../../types/UserConfig";

export const WhatIfGrid = "whatIfGrid";

export function whatIfGrid(): IComponentOptions {
    return {
        templateUrl: "app/portfolio/sidebar/what-if-grid/WhatIfGridComponent.html",
        bindings: {
            portfolio: "<",
            activeStrategyId: "<",
            strategies: "<",
            onStrategyChange: "&",
            onEdit: "&",
            onDelete: "&",
            onTradeClick: "&"
        },
        controllerAs: "ctrl",
        controller: WhatIfGridComponentController
    };
}

export class WhatIfGridComponentController implements IOnInit, IOnChanges {

    public portfolio: PortfolioPositions;
    public activeStrategyId?: number;
    public strategies: Array<Strategy>;
    public onStrategyChange: ComponentCallback;
    public onEdit: ComponentCallback;
    public onDelete: ComponentCallback;
    public onTradeClick: ComponentCallback;

    public activeStrategy?: Strategy | null = null;

    /** @ngInject */
    public constructor(private $timeout: ITimeoutService,
                       private $element: IRootElementService,
                       public userConfig: UserConfig) {

    }

    public $onInit(): void {
        if (this.activeStrategyId != null) {
            this.setActive();
            this.scrollToSelected();
        }
    }

    private scrollToSelected() {
        if (this.activeStrategy != null) {
            this.$timeout(() => {
                const targetId = ".strategy-card-" + this.activeStrategyId;
                const container = this.$element.find(".what-if-grid-container");
                const card = container.find(targetId);
                const scrollAmount = card.position().top - container.position().top;
                this.$element.find(".what-if-grid-container").slimScroll({scrollTo: scrollAmount + "px"});
            });
        }
    }

    public $onChanges(changes: IOnChangesObject): void {
        if (changes.activeStrategyId != null) {
            const idChanges = changes.activeStrategyId;
            if (this.activeStrategyId == null) {
                // This is a special case for an external change of the active strategy
                // which doesn't need an event firing for it
                this.activeStrategy = null;
            } else if (this.strategies != null && (idChanges.previousValue !== idChanges.currentValue)) {
                this.setActive();
            }
        }
    }

    private setActive() {
        this.activeStrategy = this.strategies.find(strat => strat.id === this.activeStrategyId);
        this.onStrategyChange({strategy: this.activeStrategy});
    }

    public selectStrategy($event: JQueryEventObject, strategy: Strategy) {
        if (!$event.isDefaultPrevented()) {
            if (this.activeStrategy === strategy) {
                this.activeStrategy = null;
            } else {
                this.activeStrategy = strategy;
            }
            const copy = ObjectUtil.copy(this.activeStrategy);
            this.onStrategyChange({strategy: copy});
        }
    }

    public editStrategy($event: JQueryEventObject, strategy: Strategy) {
        $event.preventDefault();
        this.onEdit({strategy});
    }

    public deleteStrategy($event: JQueryEventObject, strategy: Strategy) {
        $event.preventDefault();
        this.onDelete({strategy});
    }

    public trade($event: JQueryEventObject, strategy: Strategy) {
        $event.preventDefault();
        this.onTradeClick({strategy});
    }
}
